import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-under-maintenance',
    templateUrl: './under-maintenance.component.html',
    styleUrls: ['./under-maintenance.component.scss'],
})
export class UnderMaintenanceComponent implements OnInit, OnDestroy {
    constructor(private modalService: NgbModal) {}

    ngOnInit(): void {
        document.body.classList.add('overflow-y-hidden');
        if (this.modalService.hasOpenModals()) {
            this.modalService.dismissAll();
        }
    }

    ngOnDestroy(): void {
        document.body.classList.remove('overflow-y-hidden');
    }
}
